import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import {
  Alert,
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Snackbar,
  ThemeProvider,
} from "@mui/material";
import Select from "@mui/material/Select";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { AppContext } from "AppContext";
import { API, graphqlOperation } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { getCategoryById } from "../components/categoryHelper";
import JobRequestCard from "../components/JobRequestCard";
import theme from "../components/mainTheme";
import { listJobRequests } from "../graphql/queries";
import createSubscription from "../utils/createSubscription";
import Notification from "../components/Notification";
import CreateSubscriptionDialog from "../components/CreateSubscriptionDialog";

const NOTHING_SELECTED = " - ";

export default function AvailableJobs() {
  const appContext = React.useContext(AppContext);
  const isLoggedOn = appContext.authenticated === true;

  const [currentUser, setCurrentUser] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [listJobs, setListJobs] = useState([]);
  const [categories, setCategories] = useState([NOTHING_SELECTED]);
  const [counties, setCounties] = useState([NOTHING_SELECTED]);
  const [municipalities, setMunicipalities] = useState([NOTHING_SELECTED]);
  const [showtab, setShowtab] = useState("job");
  const [municipality, setMunicipality] = useState(NOTHING_SELECTED);
  const [category, setCategory] = useState(NOTHING_SELECTED);
  const [county, setCounty] = useState(NOTHING_SELECTED);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "success",
  });
  const [showCreateSubscription, setShowCreateSubscription] = React.useState(
    false
  );

  useEffect(() => {
    getJobs(showtab);
  }, []);

  useEffect(() => {
    //console.log("Har vi några jobs??", jobs);
    const categoriesTemp = getCategories(jobs);
    const listCategories = categoriesTemp.map(function (c) {
      if (c === NOTHING_SELECTED) {
        return c;
      }
      const displayValue = getCategoryById(c);
      return displayValue;
    });
    // console.log("categories to list: ", Object.values(listCategories));
    setCategories(listCategories);

    const listCounties = getCounties(jobs);
    setCounties(listCounties);

    const listmunicipalities = getMunicipalities(jobs, county);
    setMunicipalities(listmunicipalities);

    return () => {
      //      cleanup;
    };
  }, [jobs]);

  useEffect(() => {
    // handling category
    function updateListJobs() {
      if (
        county === NOTHING_SELECTED &&
        category !== NOTHING_SELECTED &&
        municipality === NOTHING_SELECTED
      ) {
        setListJobs(jobs.filter((job) => job.category === category));
      } else if (
        county !== NOTHING_SELECTED &&
        category !== NOTHING_SELECTED &&
        municipality === NOTHING_SELECTED
      ) {
        const tempJobs = jobs.filter((job) => job.county === county);
        setListJobs(tempJobs.filter((job) => job.category === category));
      } else if (
        county !== NOTHING_SELECTED &&
        category === NOTHING_SELECTED &&
        municipality === NOTHING_SELECTED
      ) {
        setListJobs(jobs.filter((job) => job.county === county));
      } else if (
        county === NOTHING_SELECTED &&
        category === NOTHING_SELECTED &&
        municipality === NOTHING_SELECTED
      ) {
        setListJobs(jobs);
      } else if (
        county === NOTHING_SELECTED &&
        category !== NOTHING_SELECTED &&
        municipality !== NOTHING_SELECTED
      ) {
        const tempJobs = jobs.filter((job) => job.category === category);
        setListJobs(
          tempJobs.filter((job) => job.municipality === municipality)
        );
      } else if (
        county !== NOTHING_SELECTED &&
        category !== NOTHING_SELECTED &&
        municipality !== NOTHING_SELECTED
      ) {
        let tempJobs = jobs.filter((job) => job.county === county);
        tempJobs = tempJobs.filter((job) => job.municipality === municipality);
        setListJobs(tempJobs.filter((job) => job.category === category));
      } else if (
        county !== NOTHING_SELECTED &&
        category === NOTHING_SELECTED &&
        municipality !== NOTHING_SELECTED
      ) {
        const tempJobs = jobs.filter((job) => job.county === county);
        setListJobs(
          tempJobs.filter((job) => job.municipality === municipality)
        );
      } else if (
        county === NOTHING_SELECTED &&
        category === NOTHING_SELECTED &&
        municipality !== NOTHING_SELECTED
      ) {
        setListJobs(jobs.filter((job) => job.municipality === municipality));
      }
    }
    updateListJobs();
  }, [county, category, municipality]);

  useEffect(() => {
    //console.log("Har vi några jobs??", jobs);
    const categoriesTemp = getCategories(listJobs);
    const listCategories = categoriesTemp.map(function (c) {
      if (c === NOTHING_SELECTED) {
        return c;
      }
      const displayValue = getCategoryById(c);
      return displayValue;
    });
    // console.log("categories to list: ", Object.values(listCategories));
    setCategories(listCategories);

    const listCounties = getCounties(listJobs);
    setCounties(listCounties);

    const listMunicipalities = getMunicipalities(listJobs, county);
    setMunicipalities(listMunicipalities);

    return () => {
      //      cleanup;
    };
  }, [listJobs]);

  const closeSubscriptionDialogAfterCreate = () => {
    setShowCreateSubscription(false);
    setNotify({
      isOpen: true,
      message: "Din bevakning har skapats!",
      type: "success",
    });
  };
  const closeSubscriptionDialog = () => {
    setShowCreateSubscription(false);
  };

  const up = appContext.userProfile;
  return (
    <>
      <Container maxWidth="md">
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "normal" },
              mb: { sm: 4, xs: 1 },
              mt: { sm: 4, xs: 1 },
            }}
          >
            <StatusTabs
              value={showtab}
              onChange={(value) => {
                setShowtab(value);
                getJobs(value);
              }}
            />

            <Notification notify={notify} setNotify={setNotify} />
            <Button
              sx={{
                display: { xs: "none", sm: "flex" },
                ml: 2,
                alignSelf: "center",
              }}
              variant="outlined"
              size="small"
              endIcon={<NotificationAddIcon />}
              onClick={() => setShowCreateSubscription(true)}
              aria-label="Skapa email bevakning"
            >
              Skapa Bevakning
            </Button>

            {showCreateSubscription && (
              <CreateSubscriptionDialog
                isOpen={true}
                closeDialog={closeSubscriptionDialog}
                closeAfterCreate={closeSubscriptionDialogAfterCreate}
              />
            )}

            {/** 
            <Button
              sx={{
                display: { xs: "none", sm: "flex" },
                ml: 2,
                alignSelf: "center",
              }}
              variant="outlined"
              size="small"
              endIcon={<NotificationAddIcon />}
              color="success"
              aria-label="Skapa email bevakning"
              disabled={
                category == NOTHING_SELECTED &&
                county == NOTHING_SELECTED &&
                municipality == NOTHING_SELECTED
              }
              onClick={() => {
                handleAddSubscription(
                  up.id,
                  category,
                  county,
                  municipality,
                  up.email
                );
                setNotify({
                  isOpen: true,
                  message: "Din bevakning har skapats!!",
                  type: "success",
                });
              }}
            >
              Skapa Bevakning
            </Button>
            */}
          </Grid>
          <Grid item xs={6} sm={3}>
            <DropDown
              values={categories}
              label="Välj kategori"
              name="category"
              onChange={(event) => {
                setCategory(event.target.value);
              }}
              value={category}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <DropDown
              values={counties}
              label="Välj län"
              name="county"
              onChange={(event) => setCounty(event.target.value)}
              value={county}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <DropDown
              values={municipalities}
              label="Välj kommun"
              name="municipality"
              onChange={(event) => setMunicipality(event.target.value)}
              value={municipality}
            />
          </Grid>

          <Grid
            xs={6}
            item
            sx={{
              display: { xs: "normal", sm: "none" },
            }}
          >
            <Button
              sx={{ ml: 1, mt: 1 }}
              variant="outlined"
              size="small"
              endIcon={<NotificationAddIcon />}
              onClick={() => setShowCreateSubscription(true)}
              aria-label="Skapa email bevakning"
            >
              Skapa Bevakning
            </Button>
            {/** 
            <Button
              sx={{ ml: 1, mt: 1 }}
              variant="outlined"
              size="small"
              endIcon={<NotificationAddIcon />}
              color="success"
              aria-label="Skapa email bevakning"
             disabled={
                category == NOTHING_SELECTED &&
                county == NOTHING_SELECTED &&
                municipality == NOTHING_SELECTED
              }
              onClick={() => {
                handleAddSubscription(
                  up.id,
                  category,
                  county,
                  municipality,
                  up.email
                );
                setNotify({
                  isOpen: true,
                  message: "Din bevakning har skapats!!",
                  type: "success",
                });
              }}
            >
              Skapa <br /> bevakning
            </Button>
            */}
          </Grid>
        </Grid>

        {listJobs.map(function (job, index) {
          return (
            <JobRequestCard
              userProfile={up}
              job={job}
              key={index}
              admin={false}
            />
          );
        })}
      </Container>
      <Snackbar
        style={{ spacing: "12" }}
        open={notify.isOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={(event, reason) => {
          if (reason === "clickAway") {
            return;
          }
          setNotify({ isOpen: false, message: "", type: "success" });
        }}
      >
        <Alert
          severity={notify.type}
          onClose={(event, reason) => {
            if (reason === "clickAway") {
              return;
            }
            setNotify({ isOpen: false, message: "", type: "success" });
          }}
        >
          {notify.message}
        </Alert>
      </Snackbar>
    </>
  );

  async function getJobs(tab) {
    //const allJobs = getJobsToList();
    const d = new Date(); // today!
    d.setDate(d.getDate() - 1);

    const yesterday = new Date(d).toISOString().substring(0, 10);

    const startNowFilter = {
      filter: { startNow: { eq: "startNow" }, jobType: { eq: tab } },
    };
    const obj = {
      filter: {
        startDate: { gt: yesterday },
        startNow: { eq: "startDate" },
        status: { eq: "active" },
        jobType: { eq: tab },
      },
    };
    const apiData = await API.graphql(graphqlOperation(listJobRequests, obj));
    // Get all jobs that should start now (startNow)
    const startNowData = await API.graphql(
      graphqlOperation(listJobRequests, startNowFilter)
    );

    //Remove jobs that are null from the list
    let allJobs = apiData.data.listJobRequests.items.filter(function (job) {
      return !!job;
    });

    const startNowJobs = startNowData.data.listJobRequests.items.filter(
      function (startNowJob) {
        return !!startNowJob;
      }
    );

    allJobs.sort(function (job1, job2) {
      if (job1.startDate > job2.startDate) {
        return 1;
      }
      if (job1.startDate === job2.startDate) {
        return 0;
      }
      return -1;
    });

    if (startNowJobs && startNowJobs.length > 0) {
      //console.log("startNowJobs: ", startNowJobs);

      startNowJobs.sort(function (j1, j2) {
        if (j1.createdAt < j2.createdAt) {
          return 1;
        }
        if (j1.createdAt === j2.createdAt) {
          return 0;
        }
        return -1;
      });

      allJobs.unshift(...startNowJobs);
    }
    //return allJobs;
    setJobs(allJobs);
    setListJobs(allJobs);
  }
}
/*
const handleCloseNotification = (event, reason) => {
  if (reason === "clickAway") {
    return;
  }
  this.setState({ notify: { isOpen: false, message: "", type: "success" } });
};*/

function getCategories(jobs) {
  //console.log("in getCategories and jobs is: ", jobs);
  return extractProperty(jobs, "category");
}

function getCounties(jobs) {
  return extractProperty(jobs, "county");
}
function getMunicipalities(jobs, county) {
  const arr = jobs.filter((job) => job.county === county);
  return extractProperty(arr, "municipality");
}

function extractProperty(objects, propertyName) {
  //Create an array with the value of properyName
  const resultRaw = objects.map(function (obj) {
    return obj[propertyName];
  });
  //make the values of the array unique
  let result = [...new Set(resultRaw)];
  result.sort();
  result.unshift(NOTHING_SELECTED);
  return result;
}

function getJobsByCounty(jobs, county) {
  county = county || NOTHING_SELECTED;
  jobs = jobs || [];
  const filterByCounty = (job) => {
    if (county === null) return job;
    if (county === NOTHING_SELECTED) return job;
    return job.county === county;
  };
  return jobs.filter(filterByCounty);
}

function getJobsByMunicipality(jobs, municipality) {
  municipality = municipality || NOTHING_SELECTED;
  jobs = jobs || [];
  const filterByMunicipality = (job) => {
    if (municipality === null) return job;
    if (municipality === NOTHING_SELECTED) return job;
    return job.municipality === municipality;
  };
  return jobs.filter(filterByMunicipality);
}

const handleAddSubscription = (
  userId,
  category,
  county,
  municipality,
  mail
) => {
  const cat = getCategoryById(category);
  createSubscription(userId, category, county, municipality, mail, cat.label);
};

function DropDown(props) {
  const values = props.values;
  const name = props.name;
  const label = props.label;
  const onChange = props.onChange;
  const value = props.value;
  const labelId = "jobs-by-" + name;
  //console.log("values: ", values);
  return (
    <div
      style={{
        display: "inline-block",
      }}
    >
      <FormControl sx={{ m: 1 }} variant="outlined">
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          id={name}
          name={name}
          value={value}
          label={label}
          labelId={labelId}
          onChange={onChange}
          variant="outlined"
          sx={{ minWidth: { xs: "160px", md: "180px" } }}
        >
          {values.map((c) => {
            if (!c) {
              return null;
            }

            if (typeof c === "string") {
              return (
                <MenuItem key={c} value={c}>
                  {c}
                </MenuItem>
              );
            } else {
              return (
                <MenuItem key={c.id} value={c.id}>
                  {c.label}
                </MenuItem>
              );
            }
          })}
        </Select>
      </FormControl>
    </div>
  );
}
function StatusTabs(props) {
  const value = props.value;
  const onChange = props.onChange || (() => {});

  return (
    <ThemeProvider theme={theme}>
      <Tabs
        value={value}
        indicatorColor="primary"
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
      >
        <Tab
          sx={{
            fontSize: { xs: "14px", md: "24px" },
            fontWeight: "600",
          }}
          label="Hitta Uppdrag"
          value="job"
        />
        <Tab
          sx={{
            fontSize: { xs: "14px", md: "24px" },
            fontWeight: "600",
          }}
          label="Hitta Hantverkare"
          value="worker"
        />
      </Tabs>
    </ThemeProvider>
  );
}
